import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type GuestWishlistState = {
  variantIds: number[];
  count: number;
};

const initialState: GuestWishlistState = {
  variantIds: [],
  count: 0,
};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    setGuestWishlistItems: (
      state,
      action: PayloadAction<{ variantIds: number[] }>,
    ) => {
      state.variantIds = action.payload.variantIds;
      state.count = action.payload.variantIds.length;
    },
    toggleLocalWishlistItem: (state, action: PayloadAction<{ variantId: number }>) => {
      const exists = state.variantIds.includes(action.payload.variantId);

      state.variantIds = exists
        ? state.variantIds.filter((variantId) => variantId !== action.payload.variantId)
        : [...state.variantIds, action.payload.variantId];
      state.count = state.variantIds.length;
    },
    clearGuestWishlist: (state) => {
      state.variantIds = [];
      state.count = 0;
    },
  },
});

export const {
  setGuestWishlistItems,
  toggleLocalWishlistItem,
  clearGuestWishlist,
} = wishlistSlice.actions;

export default wishlistSlice.reducer;
